import { useMultiQuery } from "@inntechcorp/it-design";
import WebContext from "Context/WebContext";
import { useContext } from "react";
import { useLocation, useNavigate } from "react-router";

import { GetLocalState } from "Connectivity/LocalStorage";

import useModalActions from "./useModalActions";

type QueryValue = {
  type    : string,
  value   : string
}

const useUserHubActions = () => {
  
  const MQ                       = useMultiQuery();
  const navigate                 = useNavigate();
  const { pathname }             = useLocation();
  const { isLoggedIn }           = useContext(WebContext);
  const { showLoginModal }       = useModalActions();

  const settings = GetLocalState("settings");

  const getSubPageByMenu = (menu:string) => {

    if ( menu === settings.values.User ) {
      return settings.values.MyProfile;
    }
    else if ( menu === settings.values.Settings ) {
      return settings.values.PersonalDetails;
    }
    else if ( menu === settings.values.Balance ) {
      return settings.values.Deposit;
    }
    else if ( menu === settings.values.History ) {
      return settings.values.Game;
    }
    else if ( menu === settings.values.Bonus ) {
      return settings.values.Request;
    }
    else if ( menu === settings.values.FreeSpin ) {
      return settings.values.FreeSpinActivation;
    }
    else if ( menu === settings.values.Messages ) {
      return settings.values.Inbox;
    }

    return "";

  }

  function openUserHub(menu:string, sub?:string) {

    if ( !isLoggedIn ) {
      showLoginModal();
      return;
    }

    if ( pathname === "/" ) {
      let path = "/home?" +     settings.queries.UserHub  + "=" + settings.values.Open;
      if ( menu ) path += "&" + settings.queries.Menu     + "=" + menu;
      if ( sub )  path += "&" + settings.queries.Sub      + "=" + sub;
      navigate(path);
    }
    else {

      let paths:QueryValue[] = [
        {
          type  : settings.queries.UserHub,
          value : settings.values.Open
        },
        {
          type  :settings.queries.Menu,
          value : menu
        }
      ];

      if ( sub ) {
        paths.push(
          {
            type  : settings.queries.Sub,
            value : sub
          }
        )
      }
      else {
        paths.push(
          {
            type  : settings.queries.Sub,
            value : getSubPageByMenu(menu)
          }
        )
      }
      
      paths = [
        ...paths,
        ...getOtherUserHubParams()
      ]

      MQ.set(paths);
    }

  }

  function removeUserHubParams(removeUserEnter:boolean = false) {

    let params = [
      ...getOtherUserHubParams(),
      {
        type  : settings.queries.UserHub,
        value : ""
      },
      {
        type  : settings.queries.Menu,
        value : ""
      },
      {
        type  : settings.queries.Sub,
        value : ""
      },
    ];

    if ( removeUserEnter ) {
      params.push(
        {
          type  : settings.queries.UserEnter,
          value : ""
        }
      )
    }

    MQ.set(params);

  }

  function getOtherUserHubParams():QueryValue[] {

    return [
      {
        type  : settings.queries.Status,
        value : ""
      },
      {
        type  : settings.queries.Category,
        value : ""
      },
      {
        type  : settings.queries.GameProviders,
        value : ""
      },
      {
        type  : settings.queries.Games,
        value : ""
      },
      {
        type  : settings.queries.StartDate,
        value : ""
      },
      {
        type  : settings.queries.EndDate,
        value : ""
      },
      {
        type  : settings.queries.PaymentType,
        value : ""
      },
      {
        type  : settings.queries.Min,
        value : ""
      },
      {
        type  : settings.queries.Max,
        value : ""
      },
      {
        type  : settings.queries.PaymentMethods,
        value : ""
      },
      {
        type  : settings.queries.Wagering,
        value : ""
      },
      {
        type  : settings.queries.MultiApply,
        value : ""
      },
      {
        type  : settings.queries.BonusType,
        value : ""
      },
      {
        type  : settings.queries.Search,
        value : ""
      },
      {
        type  : settings.queries.CreatorType,
        value : ""
      },
    ];

  }

  return {
    openUserHub,
    removeUserHubParams,
    getOtherUserHubParams
  }
  
}

export default useUserHubActions;